import { ContextMenuMESFProvider } from "../../../controls/contextMenu/useContextMenuMESF";
import { EAFProcessesPage } from "./EAFProcessesPage";
import { EAFProcessesProvider } from "./context/EAFProcessesContext";

type Props = {};
const EAFProcesses = (props: Props) => {
  return (
    <ContextMenuMESFProvider>
      <EAFProcessesProvider>
        <EAFProcessesPage />
      </EAFProcessesProvider>
    </ContextMenuMESFProvider>
  );
};
export default EAFProcesses;
